module.exports = __webpack_public_path__ + "static/media/profile.926fda93.png";